import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, mergeProps as _mergeProps, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "h-full w-full flex text-sm text-main-5"
};
const _hoisted_2 = {
  class: "h-full w-[350px] flex flex-col gap-6 p-6 pr-0 border-r border-white/50 shrink-0"
};
const _hoisted_3 = {
  class: "h-full flex flex-col overflow-y-scroll scroll pr-6"
};
const _hoisted_4 = {
  class: "h-fit w-full flex flex-col gap-4"
};
const _hoisted_5 = {
  class: "text-lg font-medium"
};
const _hoisted_6 = {
  key: 0,
  title: "Los robots para asesorias en web se encuentra actualmente en fase de BETA.",
  class: "italic text-cta2-100"
};
const _hoisted_7 = {
  key: 0,
  class: "h-6 w-6 loading-spinner-main mt-4 mx-auto shrink-0"
};
const _hoisted_8 = {
  key: 1,
  class: "w-full flex flex-col gap-2 mt-2"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "text-sm font-semibold"
};
const _hoisted_11 = {
  class: "flex flex-col gap-1 p-1.5"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "pr-6"
};
const _hoisted_14 = {
  key: 0,
  class: "h-12 w-12 loading-spinner-main m-auto"
};
const _hoisted_15 = {
  key: 1,
  class: "h-full w-full p-6 overflow-hidden"
};
const _hoisted_16 = {
  key: 0,
  class: "flex items-center flex-wrap gap-2"
};
const _hoisted_17 = {
  key: 2,
  class: "w-full p-6 flex overflow-hidden animate-fade"
};
const _hoisted_18 = {
  class: "w-[500px]"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_InputField = _resolveComponent("InputField");
  const _component_Collapsible = _resolveComponent("Collapsible");
  const _component_ScrollShadow = _resolveComponent("ScrollShadow");
  const _component_Button = _resolveComponent("Button");
  const _component_DynamicBuilder = _resolveComponent("DynamicBuilder");
  const _component_FlowsHistory = _resolveComponent("FlowsHistory");
  const _component_UserResourcesManager = _resolveComponent("UserResourcesManager");
  const _component_Modal = _resolveComponent("Modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["h-full flex justify-end overflow-hidden transition-[width,opacity] shrink-0 duration-500", _ctx.selectedFlow ? 'w-0 opacity-0 pointer-events-none' : 'w-[350px]'])
  }, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ScrollShadow, null, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("p", _hoisted_5, [_createTextVNode(_toDisplayString(_ctx.$appConfig.company_name) + " Flows ", 1), !_ctx.$embedded ? (_openBlock(), _createElementBlock("span", _hoisted_6, "| BETA")) : _createCommentVNode("", true)]), _createVNode(_component_InputField, {
      variant: "outlined_light",
      size: "sm",
      placeholder: _ctx.$st('general.search'),
      icon: "icon-search",
      modelValue: _ctx.flowsSearchKeyword,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.flowsSearchKeyword = $event)
    }, null, 8, ["placeholder", "modelValue"]), _ctx.loading.flows ? (_openBlock(), _createElementBlock("div", _hoisted_7)) : (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.GetNormalizedFlowsByGroup, flowGroup => {
      return _openBlock(), _createElementBlock("div", {
        key: flowGroup,
        class: "bg-main-10 rounded-lg"
      }, [_createElementVNode("div", {
        class: _normalizeClass(["h-10 flex items-center justify-between gap-2 rounded-md px-3 shadow-weak_material text-main-100 shrink-0 cursor-pointer bg-main-5 hover:bg-main-10 transition-colors", {
          'bg-cta2-10!': flowGroup.open
        }]),
        onClick: $event => flowGroup.open = !flowGroup.open
      }, [_createElementVNode("p", _hoisted_10, _toDisplayString(flowGroup.name), 1), _createElementVNode("i", {
        class: _normalizeClass(["icon-chevron-down text-xs transition-transform", {
          'rotate-180': flowGroup.open
        }])
      }, null, 2)], 10, _hoisted_9), _createVNode(_component_Collapsible, {
        collapsed: !flowGroup.open && !_ctx.flowsSearchKeyword
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flowGroup.flows, flow => {
          return _openBlock(), _createElementBlock("div", {
            key: flow,
            class: _normalizeClass(["flex items-center justify-between px-3 py-3 bg-main-10 hover:bg-second-10 transition-colors text-xs text-main-75 hover:text-main-100 rounded shadow-weak_material cursor-pointer", {
              'bg-cta2-75! text-main-100!': _ctx.selectedFlow?.id === flow.id
            }]),
            onClick: $event => $options.OnFlowSelect(flow.id)
          }, [_createElementVNode("p", null, _toDisplayString(flow.name), 1), _cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "flex items-center gap-1"
          }, [_createElementVNode("i", {
            class: "icon-play-rounded text-lg"
          })], -1))], 10, _hoisted_12);
        }), 128))])]),
        _: 2
      }, 1032, ["collapsed"])]);
    }), 128))]))])])]),
    _: 1
  }), _createElementVNode("div", _hoisted_13, [_ctx.$state.externalAccess ? (_openBlock(), _createBlock(_component_Button, _mergeProps({
    key: 0,
    variant: "tinted",
    icon: "icon-mr-robot",
    stretch: true,
    reversed: true
  }, _ctx.$state.externalAccess), null, 16)) : _createCommentVNode("", true)])])], 2), _ctx.loading.loadingFlowData ? (_openBlock(), _createElementBlock("div", _hoisted_14)) : _ctx.selectedFlow ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(), _createBlock(_component_DynamicBuilder, {
    key: _ctx.selectedFlow.id,
    ExecutionController: $options.OnLaunchFlow,
    back: () => _ctx.selectedFlow = undefined
  }, {
    "subheader-slot": _withCtx(() => [_ctx.selectedFlow.template || _ctx.selectedFlow.instructionsURL ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_ctx.selectedFlow.template ? (_openBlock(), _createBlock(_component_Button, {
      key: 0,
      variant: "outlined_light",
      size: "sm",
      icon: "icon-download",
      text: "Plantilla",
      reversed: true,
      onClick: _cache[1] || (_cache[1] = $event => _ctx.$download({
        blob: _ctx.selectedFlow.template,
        filename: `Plantilla ${_ctx.selectedFlow.name}`
      }))
    })) : _createCommentVNode("", true), _ctx.selectedFlow.instructionsURL ? (_openBlock(), _createBlock(_component_Button, {
      key: 1,
      variant: "outlined_light",
      size: "sm",
      icon: "icon-eye-open",
      text: "Instrucciones",
      reversed: true,
      onClick: _cache[2] || (_cache[2] = $event => _ctx.$openExternal(_ctx.selectedFlow.instructionsURL))
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["ExecutionController", "back"]))])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_FlowsHistory)]))]), _ctx.requiredMachineModal ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({
    key: 0,
    title: "¿ Dónde quieres lanzar este robot ?",
    text: "Selecciona una de los dispositivos compartidos para realizar la programación."
  }, _ctx.requiredMachineModal), {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_18, [_createVNode(_component_UserResourcesManager, {
      modelValue: _ctx.requiredMachineModal.machine,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.requiredMachineModal.machine = $event),
      type: "machines",
      selectable: true,
      multiple: false,
      includeLocalMachine: false
    }, null, 8, ["modelValue"])])]),
    _: 1
  }, 16)) : _createCommentVNode("", true)], 64);
}